import { useCallback, useEffect, useRef } from "react";
import type { sectionDataType } from "components/scrollableSection/scrollableSection";

export function useScrollableSections(
  sectionsObj: { [key: string]: sectionDataType } | undefined,
  setSectionsObj: React.Dispatch<React.SetStateAction<{ [k: string]: sectionDataType }>>
) {

  const containersRef = useRef<{ [id: string]: HTMLDivElement | null }>({});
  const sectionsRef = useRef(sectionsObj);

  useEffect(() => {
    sectionsRef.current = sectionsObj;
  }, [sectionsObj]);

  const seeMore = useCallback((id: string) => {
    setSectionsObj(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        isSeeMore: !prev[id]?.isSeeMore
      }
    }));
  }, [setSectionsObj]);

  const snapScroll = useCallback(
    (direction: string, id: string) => {
      const container = containersRef.current[id];
      if (!container) return;

      const scrollAmount = container.offsetWidth * 0.8;
      container.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    },
    []
  );

  const checkScrollableSections = () => {

    setSectionsObj(prev => {

      const updatedSections = { ...prev };

      Object.entries(containersRef.current).forEach(([id, container]) => {

        if (container) {
          updatedSections[id] = {
            ...updatedSections[id],
            isScrollable: container.scrollWidth > container.clientWidth
          };
        }
      });

      return updatedSections;

    });
  };

  return {
    seeMore,
    snapScroll,
    checkScrollableSections,
    containersRef,
  };
}